import React from 'react';
import { Link } from 'react-router-dom';
import Particles from '../components/Particles';
import Footer from '../components/Footer';
import holyFace from '../assets/holy-face.png';
import './Home.css';

export default function Home() {
    return (
        <>
            <Particles />
            <div className="hero">
                <div
                    className="hero__veil"
                    style={{ backgroundImage: `url(${holyFace})` }}
                />

                <div className="hero__content fade-up">
                    <p className="section-label">Veneration &amp; Devotion</p>
                    <h1 className="hero__title">
                        The Holy Face<br />
                        <em>of Jesus</em>
                    </h1>
                    <p className="hero__sub">
                        "He had no form or majesty that we should look at Him, and no beauty
                        that we should desire him."
                        <span className="hero__ref">— Isaiah 53:2</span>
                    </p>
                </div>

                <div className="scroll-hint">
                    <span />
                    <p>Scroll</p>
                </div>
            </div>

            {/* Quick-nav tiles */}
            <section className="quick-nav">
                <div className="quick-nav__inner">
                    {[
                        // { to: '/shroud',   icon: '☩', title: 'The Shroud of Turin',     sub: 'The sacred burial cloth' },
                        { to: '/veil',     icon: '✦', title: 'The Veil of Veronica',    sub: 'A tradition of compassion' },
                        { to: '/devotion', icon: '✧', title: 'Devotion Through the Ages', sub: 'Saints and witnesses' },
                        { to: '/prayer',   icon: '✶', title: 'The Golden Arrow',         sub: 'A prayer of reparation' },
                    ].map(({ to, icon, title, sub }) => (
                        <Link key={to} to={to} className="tile">
                            <span className="tile__icon">{icon}</span>
                            <h3 className="tile__title">{title}</h3>
                            <p className="tile__sub">{sub}</p>
                            <span className="tile__arrow">→</span>
                        </Link>
                    ))}
                </div>
            </section>

            <Footer />
        </>
    );
}